import { render, staticRenderFns } from "./xskLogistics.vue?vue&type=template&id=9c5bbcc6&scoped=true&"
import script from "./xskLogistics.vue?vue&type=script&lang=js&"
export * from "./xskLogistics.vue?vue&type=script&lang=js&"
import style0 from "./xskLogistics.vue?vue&type=style&index=0&lang=css&"
import style1 from "./xskLogistics.vue?vue&type=style&index=1&id=9c5bbcc6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5bbcc6",
  null
  
)

export default component.exports